import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Type, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { EntityListAction, Permission, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { InvGoodsKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { GoodsFormulaDetail } from "../../../models/goods-formula-detail.model";
import { Goods } from "../../../models/goods.model";
import { GoodsFormulaFormComponent } from "../goods-formula-form/goods-formula-form.component";

@Component({
  selector: "ngx-goods-formula-view-form",
  templateUrl: "./goods-formula-view-form.component.html",
  styleUrls: ["./goods-formula-view-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoodsFormulaViewFormComponent extends BaseFormComponent<Goods> {
  public GoodsFormulaDetailsColumns: any;
  datList: GoodsFormulaDetail[] = [];
  inputEditorform: Type<any>;
  actions: EntityListAction[];
  @ViewChild("goodsFormulaView") public goodsFormulaView: KGridComponent;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.inputEditorform = GoodsFormulaFormComponent;
  }
  async ngOnInit() {
    this.noLoadData = true;
    this.model = Object.assign({}, this.currentrow);
    super.ngOnInit();
    this.setFormGroup(this.model);
    this.setactions();
    this.setData();
  }
  addControl() {
    this.cd.markForCheck();
  }
  async save() {
    if (this.formGroup?.valid) {
      this.closeModal();
    }
  }
  async setData() {
    await this.httpCommonService
      .getList(`Goods/GetGoodsFormulaDetailByGoodsId/${this.currentrow.GoodsId}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then((data: GoodsFormulaDetail[]) => {
        this.datList = data;
        if (this.goodsFormulaView) this.goodsFormulaView.dataList = data;
        this.cd.markForCheck();
      });
  }
  cancel() {
    this.closeModal();
  }
  setactions() {
    this.actions = [
      {
        name: "GetGoodsFormula",
        disabled: false,
        displayName: "اجزاء تشکیل دهنده کالا",
        iconName: "icon-gears1",
        apiName: "Goods/GetGoodsFormula",
        areaName: "Inventory",
        requireSelectedrows: true,
        Form_Component: GoodsFormulaViewFormComponent,
        permission: Permission.viewPermission,
      },
    ];
  }
  onActionClick(action: EntityListAction, onRowSelected: Goods, onRowsSelected: Goods[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    ///کالای تولید / نیم ساخته
    if (
      action.name === "GetGoodsFormula" &&
      onRowSelected &&
      onRowSelected.GoodsKindCode !== InvGoodsKind.Product &&
      onRowSelected.GoodsKindCode !== InvGoodsKind.HalfMade
    ) {
      this.sts.showDialog("فقط کالا از نوع محصول /نیم ساخته قابل انتخاب است.", "");
    }
    ///اجزاء تشکیل دهنده کالا
    else if (action.name === "GetGoodsFormula") {
      this.dialogService
        .open(
          action.Form_Component,
          {
            currentrow: onRowSelected,
            apiName: action.apiName,
            areaName: action.areaName,
            GoodsFormulaDetailsColumns: this.columns,
            label: "اجزاء تشکیل دهنده کالا",
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {});
    }
  }
}
